import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=4d41e4f9"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=4d41e4f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports